<div class="main">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="meetings-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="meetings-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()" aria-label="Go back to Meetings">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to Meetings
                </button>
                <h3>{{ isEditMode ? 'Edit Meeting' : 'Create Meeting' }}</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="meetings-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + AppConstants.ROUTES.MEETINGS]" class="meetings-header-title breadcrumb-link">Meetings <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span>{{ isEditMode ? 'Edit Meeting' : 'Create Meeting' }}</span>
                </span>
            </div>
        </div>

        <!-- Form Section -->
        <div class="mandatory-application m-4">
            <div class="inside-out p-4">
                <div class="mandatory-fields">
                    <div class="mandatory-line">
                        <span class="mandatory-par">
                            Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                        </span>
                    </div>
                </div>
                <form [formGroup]="meetingForm" (ngSubmit)="onCreate()">
                    <div class="container pt-4">
                        <br>
                        <!-- Basic Information Section -->
                        <div class="address-title mb-3">
                            <h4 class="fw-bold">Basic Information</h4>
                        </div>

                        <div class="row mb-4">
                            <!-- Meeting Title -->
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="meetingTitle" class="form-label fw-bold">Meeting Title <span style="color: red;font-size: 1rem;">*</span></label>
                                    <input 
                                        type="text" 
                                        id="meetingTitle" 
                                        class="form-control rounded-4 bg-light p-2" 
                                        [class.is-invalid]="meetingForm.get('meetingTitle')?.invalid && meetingForm.get('meetingTitle')?.touched"
                                        formControlName="meetingTitle"
                                        placeholder="">
                                    <div *ngIf="meetingForm.get('meetingTitle')?.invalid && meetingForm.get('meetingTitle')?.touched" class="invalid-feedback d-block">
                                        Meeting title is required
                                    </div>
                                </div>
                            </div>
                            <!-- Meeting Id -->
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="meetingId" class="form-label fw-bold">Meeting id</label>
                                    <input 
                                        type="text" 
                                        id="meetingId" 
                                        class="form-control rounded-4 bg-light p-2" 
                                        formControlName="meetingId"
                                        [disabled]="true"
                                        placeholder="">
                                </div>
                            </div>
                        </div>

                        <!-- Date / Time and Location -->
                        <div class="row mb-4">
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="dateTime" class="form-label fw-bold">Date / Time <span style="color: red;font-size: 1rem;">*</span></label>
                                    <input 
                                        type="datetime-local" 
                                        id="dateTime" 
                                        class="form-control rounded-4 bg-light p-2" 
                                        [class.is-invalid]="meetingForm.get('dateTime')?.invalid && meetingForm.get('dateTime')?.touched"
                                        formControlName="dateTime">
                                    <div *ngIf="meetingForm.get('dateTime')?.invalid && meetingForm.get('dateTime')?.touched" class="invalid-feedback d-block">
                                        Date and time is required
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <label for="location" class="form-label fw-bold">Location <span style="color: red;font-size: 1rem;">*</span></label>
                                    <select 
                                        id="location" 
                                        class="form-control rounded-4 bg-light p-2" 
                                        [class.is-invalid]="meetingForm.get('location')?.invalid && meetingForm.get('location')?.touched"
                                        formControlName="location">
                                        <option value="">Select Location</option>
                                        <option *ngFor="let location of locationOptions" [value]="location">{{ location }}</option>
                                    </select>
                                    <div *ngIf="meetingForm.get('location')?.invalid && meetingForm.get('location')?.touched" class="invalid-feedback d-block">
                                        Location is required
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Committee Setup Section -->
                        <div class="address-title mb-3 mt-4">
                            <h4 class="fw-bold">Committee Setup</h4>
                        </div>
                        
                        <!-- Members Invited -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label class="form-label fw-bold">Members Invited <span style="color: red;font-size: 1rem;">*</span></label>
                                    <div class="custom-dropdown p-2 form-control rounded-4 bg-light members-disabled" *ngIf="!isLoading" [ngClass]="{ 'is-invalid': selectedMembers.length === 0 && meetingForm.touched }">
                                        <div *ngIf="getNonObserverMembers().length === 0" class="text-muted p-2">No members available</div>
                                        <ng-container *ngFor="let member of getNonObserverMembers()">
                                            <div 
                                                class="dropdown-item"
                                                [ngClass]="{ 'selected': isMemberSelected(member), 'chairman-item': member.fullName === chairmanName }">
                                                <div class="member-content">
                                                    <span class="member-name">
                                                        {{ member.fullName }}
                                                        <span *ngIf="member.isHoster" class="ms-1">(Hoster)</span>
                                                    </span>
                                                    <span class="member-role" *ngIf="member.role">{{ getMemberRole(member) }}</span>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div *ngIf="isLoading" class="text-muted p-2">Loading members...</div>
                                    <div *ngIf="selectedMembers.length === 0 && meetingForm.touched" class="invalid-feedback d-block">
                                        At least one member must be selected
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Observers -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label class="form-label fw-bold">Observers</label>
                                    <!-- Search Input -->
                                    <div class="mb-2">
                                        <input 
                                            type="text" 
                                            class="form-control rounded-4 bg-light" 
                                            placeholder="Search by name, email, or role..."
                                            [(ngModel)]="observerSearchTerm"
                                            (ngModelChange)="onObserverSearchChange()"
                                            [ngModelOptions]="{standalone: true}">
                                    </div>
                                    <!-- Selected Observers Display -->
                                    <div class="mb-2" *ngIf="selectedObservers.length > 0">
                                        <div class="selected-agenda-items">
                                            <div *ngFor="let observer of selectedObservers" class="selected-agenda-badge">
                                                <span class="badge-text">{{ observer.fullName }}</span>
                                                <button type="button" class="remove-badge-btn" (click)="toggleObserverSelection(observer)" aria-label="Remove">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Dropdown List -->
                                    <div class="custom-dropdown p-2 form-control rounded-4 bg-light" *ngIf="!isLoading">
                                        <div *ngIf="filteredObservers.length === 0 && allObservers.length === 0" class="text-muted p-2">
                                            No observers available
                                        </div>
                                        <div *ngIf="filteredObservers.length === 0 && allObservers.length > 0" class="text-muted p-2">
                                            No observers match your search
                                        </div>
                                        <div 
                                            *ngFor="let observer of filteredObservers" 
                                            class="dropdown-item" 
                                            [ngClass]="{ 'selected': isObserverSelected(observer) }"
                                            (click)="toggleObserverSelection(observer)">
                                            <div class="member-content">
                                                <span class="member-name">{{ observer.fullName }}</span>
                                                <span class="member-role" *ngIf="observer.role">{{ getMemberRole(observer) }}</span>
                                                <span class="member-email text-muted small ms-2" *ngIf="observer.email">{{ observer.email }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="isLoading" class="text-muted p-2">Loading observers...</div>
                                </div>
                            </div>
                        </div>

                        <!-- Agenda Setup Section -->
                        <div class="address-title mb-3 mt-4">
                            <h4 class="fw-bold">Agenda Setup</h4>
                        </div>
                        
                        <!-- Add Agenda Item(s) (Required) -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label class="form-label fw-bold">Add Agenda Item(s) <span style="color: red;font-size: 1rem;">*</span></label>
                                    <!-- Search Input -->
                                    <div class="mb-2">
                                        <input 
                                            type="text" 
                                            class="form-control rounded-4 bg-light" 
                                            placeholder="Search by subject, PR number, or stage..."
                                            [(ngModel)]="agendaSearchTerm"
                                            (ngModelChange)="onAgendaSearchChange()"
                                            [ngModelOptions]="{standalone: true}">
                                    </div>
                                    <!-- Selected Items Display -->
                                    <div class="mb-2" *ngIf="selectedAgendaItems.length > 0">
                                        <div class="selected-agenda-items-ordered">
                                            <div *ngFor="let item of selectedAgendaItems; let i = index" 
                                                 class="selected-agenda-badge-ordered"
                                                 draggable="true"
                                                 (dragstart)="onDragStart(i)"
                                                 (dragover)="onDragOver($event, i)"
                                                 (drop)="onDrop($event, i)"
                                                 (dragend)="onDragEnd()">
                                                <span class="item-number">Item #{{ i + 1 }}</span>
                                                <span class="drag-handle" title="Drag to reorder">
                                                    <i class="fas fa-grip-vertical"></i>
                                                </span>
                                                <div class="badge-content">
                                                    <div class="badge-pr-stage-line">
                                                        <span class="badge-pr" *ngIf="item.prIdentifiers && item.prIdentifiers.length > 0">
                                                            <span *ngFor="let pr of item.prIdentifiers; let last = last">
                                                                {{ pr }}<span *ngIf="!last">, </span>
                                                            </span>
                                                        </span>
                                                        <span class="badge-stage" [ngClass]="getAgendaStageClass(item.currentStage)" *ngIf="item.currentStage">
                                                            <i class="fas fa-tag"></i> {{ item.currentStage }}
                                                        </span>
                                                    </div>
                                                    <div class="badge-subject-line">
                                                        <span class="badge-subject">{{ item.subject }}</span>
                                                    </div>
                                                </div>
                                                <button type="button" class="remove-badge-btn" (click)="toggleAgendaItemSelection(item)" aria-label="Remove">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <p class="text-muted small mt-2 mb-0">
                                            <i class="fas fa-info-circle"></i> Drag items to reorder. Item #1 will be discussed first.
                                        </p>
                                    </div>
                                    <!-- Dropdown List -->
                                    <div class="custom-dropdown p-2 form-control rounded-4 bg-light agenda-dropdown-container" *ngIf="!isLoading" [ngClass]="{ 'is-invalid': selectedAgendaItems.length === 0 && meetingForm.touched }">
                                        <div *ngIf="filteredAgendaItems.length === 0" class="text-muted p-2">
                                            {{ existingAgendaItems.length === 0 ? 'No agenda items available' : 'No agenda items match your search' }}
                                        </div>
                                        <div 
                                            *ngFor="let item of filteredAgendaItems" 
                                            class="dropdown-item agenda-dropdown-item" 
                                            [ngClass]="{ 'selected': isAgendaItemSelected(item) }"
                                            (click)="toggleAgendaItemSelection(item)">
                                            <div class="agenda-content">
                                                <div class="agenda-header">
                                                    <span class="agenda-subject">{{ item.subject }}</span>
                                                    <span class="agenda-stage-badge" [ngClass]="getAgendaStageClass(item.currentStage)" *ngIf="item.currentStage">
                                                        {{ item.currentStage }}
                                                    </span>
                                                </div>
                                                <div class="agenda-details" *ngIf="item.prIdentifiers && item.prIdentifiers.length > 0">
                                                    <span class="agenda-pr-label">PR:</span>
                                                    <span *ngFor="let pr of item.prIdentifiers; let last = last" class="agenda-pr">
                                                        {{ pr }}<span *ngIf="!last">, </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="selectedAgendaItems.length === 0 && meetingForm.touched" class="invalid-feedback d-block">
                                        At least one agenda item must be selected
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Meeting Notes -->
                        <div class="row mb-4" *ngIf="selectedAgendaItems.length > 0">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label class="form-label fw-bold">Meeting Notes</label>
                                    <textarea 
                                        class="form-control rounded-4 bg-light p-2 agenda-notes" 
                                        rows="6" 
                                        formControlName="agendaNotes"
                                        placeholder=""></textarea>
                                </div>
                            </div>
                        </div>


                        <!-- Attachments Section -->
                        <div class="address-title mb-3 mt-4">
                            <h4 class="fw-bold">Attachments</h4>
                        </div>
                        
                        <app-file-upload
                            #fileUploadComponent
                            label="Attachments"
                            placeholderText="Click or drag files here to upload (ToR, BOQ, Technical Specifications, etc.)"
                            [multiple]="true"
                            inputId="meeting-attachments-upload"
                            [isRequired]="false"
                            [formControl]="$any(meetingForm.get('attachments'))"
                            [disabled]="false">
                        </app-file-upload>
                    </div>

                    <!-- Footer Button -->
                    <div class="form-footer">
                        <button type="submit" class="btn create-btn">{{ isEditMode ? 'Update' : 'Create' }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
